import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
  })
  export class LocalStorageService {
    isLogin = false;
    isCampus = false;
    organizationLogo:any;
    role:any;
    profile_name:any;
    userId:any
    campus_id:any;
    dept_id:any;
    organization_id:any;
    dashboard:any;
    organization_package:any;
    specialty:any;
    permissions:any;
    leadChannels:any;
    features:any;
  

    constructor( private router: Router) { }
  
    login(resp: any) {
    //  console.log(resp)
      this.isLogin = true;
      this.role =  resp.role.role_name;
      localStorage.setItem("leadChannels", resp.client?.leadChannels || null);
      localStorage.setItem('campus_id', resp.campus_id);
      localStorage.setItem('dept_id', resp.dept_id);
      localStorage.setItem('role_id', resp.role_id);
      localStorage.setItem('organization_id', resp.organization_id);
      localStorage.setItem('user_id', resp.user_id);
      localStorage.setItem('profile_name', resp.fname+" "+resp.lname);
      localStorage.setItem('fname', resp.fname);
      localStorage.setItem('lname', resp.lname);
      localStorage.setItem('role', resp.role?.name);
      localStorage.setItem('organizationLogo', resp.organization.logo);
      localStorage.setItem('organization_package', resp.organization_package);
      localStorage.setItem('permissions', JSON.stringify(resp.role.permission));
      localStorage.setItem('emailId', resp.email);
      localStorage.setItem("isCampus",resp.organization?.is_campus);
      localStorage.setItem("features",JSON.stringify(resp.features));
      localStorage.setItem('profilePicture', resp?.picture);

      localStorage.setItem('user_sign', JSON.stringify(resp.user_sign));
      let username = resp.username.replace(/([A-Z])/g, ' $1').trim();
      localStorage.setItem('username',username);

      if(resp.organization.logo)
      {
        this.toDataUrl(resp.organization.logo,this.getBase64Logo)
      }
  
      return { success: this.isLogin, role: this.role };
    }
  
    logout() {
      this.isLogin = false;
      this.role = '';
      localStorage.setItem("leadChannels","");
      localStorage.setItem('campus_id',"");
      localStorage.setItem('dept_id', "");
      localStorage.setItem('organization_id', "");
      localStorage.setItem('role_id', "");
      localStorage.setItem('user_id', "");
      localStorage.setItem('profile_name', "");
      localStorage.setItem('role', "");
      localStorage.setItem('permissions', "");
      localStorage.setItem('specialty', "");
      localStorage.setItem('token', "");
      localStorage.setItem('username',"");
      localStorage.setItem('enablePrintLayout',"");
      localStorage.setItem('getBase64HeaderPrescription',"");
      localStorage.setItem('getBase64FooterPrescription',"");
      localStorage.setItem('getBase64logo',"");
      localStorage.setItem('organizationLogo', "");
      localStorage.setItem('organization_package', "");
      localStorage.setItem('isCampus', "");
      localStorage.setItem('is_fixed_col', "");
      localStorage.setItem('get_location', "");
      localStorage.setItem('user_sign', "");
      localStorage.setItem('emailId', "");
      localStorage.setItem('features', "");
      localStorage.setItem('profilePicture', "");
      localStorage.setItem('fname', "");
      localStorage.setItem('lname', "");
  
      return { success: this.isLogin, role: '' };
    }



    getClientLogo() {
      return localStorage.getItem('clientLogo');
    }
  
    getCron() {
      return localStorage.getItem('is_cron');
    }
    getIsCenter() {
      if (localStorage.getItem('isCenter') == 'True')
        this.isCampus = true;
      else
        this.isCampus = false;
      return this.isCampus;
    }
    getEmail() {
      return localStorage.getItem('emailId');
    }
    isLoggedIn() {
      const loggedIn = localStorage.getItem('isLogin');
      if (loggedIn == 'true')
        this.isLogin = true;
      else
        this.isLogin = false;
      return this.isLogin;
    }
    
    getLeadChannels() {
      this.leadChannels = localStorage.getItem('leadChannels');
      return this.leadChannels;
    }
    getOrganizationPackage()
    {
      this.organization_package = localStorage.getItem('organization_package');
      return this.organization_package;
    }
    getRole() {
      this.role = localStorage.getItem('role');
      return this.role;
    }
    getSpecialty() {
      this.specialty = localStorage.getItem('specialty');
      return this.specialty;
    }

    getFeatures() {
      this.features = localStorage.getItem('features');
      return this.features;
    }

    getPermissions() {
      this.permissions = localStorage.getItem('permissions');
      return this.permissions;
    }

    getFeatureModules() {
      this.features = localStorage.getItem('features');
      return this.features;
    }

    getCampusId() {
      this.campus_id = localStorage.getItem('campus_id');
      return this.campus_id;
    }

    setCampusId(campus_id:any) {
      localStorage.setItem('campus_id', campus_id);
    }

    getOrganizationId() {
      this.organization_id = localStorage.getItem('organization_id');
      return this.organization_id;
    }
    getSignatures() {
      let singatures = localStorage.getItem('user_sign');
      return JSON.parse(singatures || '[]');
    }

    getProfileName() {
      this.profile_name = localStorage.getItem('profile_name');
      return this.profile_name;
    }

    getProfilePicture() {
      return localStorage.getItem('profilePicture');
    }

    getUser(){
      const user = {
        fname: localStorage.getItem('fname'),
        lname: localStorage.getItem('lname'),
        email : localStorage.getItem('emailId'),
      }

      return user;
    }

    getUserId() {
      this.userId = localStorage.getItem('user_id');
      return this.userId;
    }
    
    getDashboard() {
        this.dashboard = localStorage.getItem("dashboards")?.split(',');
        return this.dashboard;
      }
    
    getDashboardAccess(dashboardName:any)
    {
        let dashboard:any  =   localStorage.getItem("dashboards")?.split(',');
        console.log(dashboardName+"--"+dashboard)
        let isAuthenticated = false;
        if(dashboard)
        {
            return isAuthenticated =  dashboard.includes(dashboardName)
        }
      

    }
    getBase64HeaderPrescription(data:any){
      localStorage.setItem('getBase64HeaderPrescription', data)
    }
    getBase64FooterPrescription(data:any){
      localStorage.setItem('getBase64FooterPrescription', data)
    }
    getBase64Logo(data:any){
      localStorage.setItem('getBase64logo',data);
    }

    getClientCurrency()
    { 
      console.log(localStorage.getItem('currency'))
      return localStorage.getItem('currency');
    }


    toDataUrl(url:any, callback:any) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
          var reader = new FileReader();
          reader.onloadend = function() {
              callback(reader.result);
          }
          reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
  }

  checkFeatures(module:any)
  {
   let features =  JSON.parse(JSON.stringify(this.organization_package));
   return (features.includes(module) ? true : false);
  }

  checkCRUDAccess(module:any,submodule:any)
  {
    let accessObj = {
      "title": "",
      "name": "",
      "active": false,
      "update": false,
      "export": false,
      "import": false,
      "create": false,
      "delete": false
  }
   let features  = JSON.parse(this.getPermissions()).find((item:any)=>{
      return  item.module_name  == module;
  })
  if(features) {
    accessObj = {...accessObj,...features['features'].find((item:any)=>{
      return  item.name  == submodule;
    })}
  }

   return accessObj;
  }

  checkUserAccess(module_name:any,feature_name:any)
  {
        //console.log(this.permissions)
        let feature  = [];
        let module = [];
        module = this.permissions.filter((item:any)=>{
        return  item.module_name  == module_name;
        })
        if(module.length > 0)
        {
        feature = module[0]['features'].filter((item:any)=>{
          return  item.name  == feature_name;
          })
        }

        return (module[0] && feature[0] ) ? true : false;
  }

  checkFullAccessForTableList(role:any)
  {
   const roles = [
    'Administrator',
    'Superadmin',
    'Admin',
    'admin',
    'administrator',
    'Receptionist',
    'receptionist',
    'reception',
    'Reception',
   ]
   return roles.includes(role);
  }

  
  }
